import { useLayoutEffect, useRef } from "react";
import navStyle from "../styles/nav.module.scss";
import { closeIcon } from "./Icons";
import {
  MENU_HOVER_CLOSE_MS,
  MENU_HOVER_REWIND_MS,
} from "../utilities/hoverTimeoutClose";

const RING_RADIUS = 12.5;
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;

function TimeoutCloseButton({
  onClick,
  countdownToken = 0,
  durationMs = MENU_HOVER_CLOSE_MS,
  ariaLabel,
}) {
  const progressRef = useRef(null);
  const counting = countdownToken > 0;

  useLayoutEffect(() => {
    const circle = progressRef.current;
    if (!circle) {
      return undefined;
    }

    if (counting) {
      circle.style.transition = "none";
      circle.style.strokeDashoffset = String(RING_CIRCUMFERENCE);
      void circle.getBoundingClientRect();
      circle.style.transition = `stroke-dashoffset ${durationMs}ms linear`;
      circle.style.strokeDashoffset = "0";
      return undefined;
    }

    circle.style.transition = `stroke-dashoffset ${MENU_HOVER_REWIND_MS}ms linear`;
    circle.style.strokeDashoffset = String(RING_CIRCUMFERENCE);
    return undefined;
  }, [counting, countdownToken, durationMs]);

  return (
    <button
      type="button"
      className={navStyle.filterCloseButton}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <svg
        className={navStyle.closeTimeoutRing}
        viewBox="0 0 28 28"
        aria-hidden="true"
      >
        <circle
          className={navStyle.closeTimeoutTrack}
          cx="14"
          cy="14"
          r={RING_RADIUS}
        />
        <circle
          ref={progressRef}
          className={navStyle.closeTimeoutProgress}
          cx="14"
          cy="14"
          r={RING_RADIUS}
          style={{ strokeDasharray: RING_CIRCUMFERENCE }}
        />
      </svg>
      {closeIcon}
    </button>
  );
}

export default TimeoutCloseButton;
